module.exports = __webpack_public_path__ + "static/media/仓库.1707ed32.svg";